import styled from 'styled-components';

import { OptProps } from './interface';

export const Container = styled.div`
  width: 340px;
  height: 100%;
  position: fixed;
  padding: 0px;
  left: 0px;
  top: 0px;
  background: ${({ theme }) => theme.colors.MENU_BG};
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06);
  overflow-y: auto !important;

  display: flex;
  flex-direction: column;
  z-index: 3000;
  padding: 0rem;

  .menu-mobile-show {
    display: flex;
  }
  .menu-mobile-hide {
    display: flex;
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
    max-height: 100%;

    .menu-mobile-show {
      display: block;
    }
    .menu-mobile-hide {
      display: none;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  border-bottom: none;
  border-top: none;
  overflow-y: auto;

  @media (max-width: 1024px) {
    margin-top: 0rem;
    padding: 0 0 1rem 0;
  }
`;

export const Mobile = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    padding: 10px;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.MENU_BG};
    border: 1px solid rgba(0, 0, 0, 0.1);
    height: 4rem;

    div {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 10px 0;

      img {
        float: left;
        height: auto;
        max-width: 200px;
        max-height: 30px;
      }
    }
  }

  button {
    background: none;
  }
`;

export const Header = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 1rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
`;

export const Connection = styled.div`
  float: left;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 15px 15px 15px;

  background: rgba(255, 255, 255, 0.08);

  main {
    float: left;
    width: 100%;
    display: flex;
    flex-direction: row;
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    padding: 10px;

    i {
      margin: 0 5px 0 0;
    }

    div {
      float: left;
      width: 100%;
      display: flex;
      flex-direction: column;

      h1 {
        font-size: 12px;
        color: #fff;
      }

      h2 {
        font-size: 10px;
        color: #ccc;
      }
    }
  }

  &.online {
    h2 {
      color: rgba(10, 177, 33, 1) !important;
    }
  }

  &.offline {
    main {
      border-color: rgba(2228, 8, 8, 0.5);
    }
    h2 {
      color: rgba(233, 24, 24, 1) !important;
    }
  }
`;

export const LogoClient = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  float: left;
  width: 100%;
  padding: 3rem 0;
  background: rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  img {
    max-width: 16rem;
  }

  @media (max-width: 1024px) {
  }
`;

export const Ic = styled.div`
  float: left;
  background: ${({ theme }) => theme.colors.MENU_IC};
  border: 0.2rem solid rgba(0, 0, 0, 0.2);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  div {
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      float: left;
      width: 100%;
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Information = styled.div`
  padding: 0px 0px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0rem;
  flex: 1;

  h1 {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.MENU_TEXT};
    font-weight: 700;
    text-align: left;
  }

  p {
    font-size: 0.7rem;
    color: ${({ theme }) => theme.colors.MENU_TEXT};
    text-align: left;
    padding: 0rem;
    opacity: 0.6;
  }

  button {
    background: none;
    color: #fff;
    font-weight: 700;
    font-size: 0.8rem;
    transition: all 0.5s ease;
    cursor: pointer;
    margin: 0.2rem 0 0 0;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 1024px) {
  }
`;

export const Opts = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  float: left;
  margin-top: 0px;
  flex: 1;
  padding: 0rem;

  @media (max-width: 1024px) {
    padding: 0rem;
  }
`;

export const Opt = styled.button<OptProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  border-radius: 0rem;

  background: ${({ theme, active }) =>
    active ? theme.colors.MENU_LINK_BG_HOVER : theme.colors.MENU_LINK_BG};

  float: left;
  width: 100%;
  padding: 0px 0px;
  transition: all 0.5s ease;
  cursor: pointer;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 0 0 0rem 0;

  &:last-child {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &:hover {
    span {
      text-decoration: underline;
    }
  }

  i {
    float: left;
    width: 3.5rem;
    height: 3.5rem;
    background: rgba(0, 0, 0, 0.02);
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.6rem 0 0 0.6rem;
  }

  span {
    color: ${({ theme, active }) =>
      active ? theme.colors.MENU_LINK_TEXT_HOVER : theme.colors.MENU_LINK_TEXT};

    font-size: 0.8rem;
    margin-left: 0.5rem;
  }
`;

export const MobileAccount = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  float: left;
  width: 100%;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  img {
    max-width: 10rem;
  }

  span {
    color: ${({ theme }) => theme.colors.MENU_VERSION};
    font-size: 0.6rem;
    margin-top: 0rem;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NotificationCount = styled.button.attrs({
  type: 'button',
})`
  float: left;
  background: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.5s ease;
  border: 1px solid rgba(0, 0, 0, 0.5);

  &:hover {
    background: rgba(0, 0, 0, 0.4);
  }

  strong {
    background: #000;
    color: #fff;
    font-size: 12px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -10px 0 0 -12px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
